import { MainHeader } from "../../common/components/MainHeader";
import { Grid } from "semantic-ui-react";
import React from "react";
import { HeaderItem } from "../../common/components/HeaderItem";
import { Icons } from "../../common/Icons";
import { useAsync } from "react-async";
import { AxiosAreasAPI } from "../Api";
import { PlaceholderHeader } from "../../common/components/PlaceholderHeader";

const AreaHeader = ({ area }) => {
  let startDate = area.current_record?.timespan.lower;
  let dateSubtitle =
    startDate && `Desde ${startDate.format()} (${startDate.fromNow()})`;

  return (
    <div>
      <MainHeader title={area.name} subtitle={dateSubtitle} />
      <Grid stackable style={{ marginTop: "0", marginBottom: "0" }}>
        <Grid.Column width={2}>
          <HeaderItem icon={Icons.CODE} label="Código" value={area.code} />
        </Grid.Column>
        <Grid.Column width={2}>
          <HeaderItem
            icon={Icons.EMPLOYEE_COUNT}
            label="Funcionários"
            value={area.employee_count}
          />
        </Grid.Column>
        <Grid.Column width={12}>
          <HeaderItem
            icon={Icons.PARENT_AREA}
            label="Área-pai"
            value={area.parent_info ? area.parent_info.name : "-"}
          />
        </Grid.Column>
      </Grid>
    </div>
  );
};

export const AreaDetailHeader = ({ area_id }) => {
  const { isPending, data, error } = useAsync({
    promiseFn: AxiosAreasAPI.getById,
    watch: area_id,
    area_id: area_id,
  });

  if (isPending) return <PlaceholderHeader />;
  if (error) return <MainHeader title="(Área desconhecida)" />;
  if (data) return <AreaHeader area={data} />;

  return null;
};
